import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
// Función para actualizar favicon
const updateFavicon = (url: string) => {
  // Buscar el link de favicon existente
  let link = document.querySelector("link[rel='icon']") as HTMLLinkElement;
  
  if (!link) {
    // Si no existe, crearlo
    link = document.createElement('link');
    link.rel = 'icon';
    document.head.appendChild(link);
  }

  link.type = 'image/x-icon';
  
  // Actualizar el href
  link.href = url;
};

// Cargar el favicon canónico desde la API.
updateFavicon('/api/cistcor-logo/favicon.ico');
ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
